export const GET_FILES_COMMON = 'GET_FILES_COMMON';
export const GET_FILES_COMMON_SUCCESS = 'GET_FILES_COMMON_SUCCESS';
export const GET_FILES_COMMON_FAIL = 'GET_FILES_COMMON_FAIL';
export const GET_FILES_COMMON_RESET = 'GET_FILES_COMMON_RESET';
